
export const SUPER_USER = 'SU';
export const ORGANISATION_ADMIN = 'OA';
export const ORGANISATION_STAFF = 'OS';
export const GOVERNOR = 'GOV';
export const PARENT = 'PARENT';

export const USER_ROLE_CODES = {
  SUPER_USER,
  ORGANISATION_ADMIN,
  ORGANISATION_STAFF,
  GOVERNOR,
  PARENT
};

export const USER_ROLE_IDENTIFIERS = {
  [SUPER_USER]: 1,
  [ORGANISATION_ADMIN]: 2,
  [ORGANISATION_STAFF]: 3,
  [GOVERNOR]: 4,
  [PARENT]: 5
};
